import { SRGBColorSpace, MeshBasicMaterial, Mesh, PlaneGeometry, Group, LinearFilter, LinearMipmapLinearFilter, ClampToEdgeWrapping } from "three";
import VaultHero from "./VaultHero";
import gsap from "gsap";

export default class BackgroundStars {
    constructor() {
        this.experience = new VaultHero()
        this.sizes = this.experience.sizes
        this.scene = this.experience.scene
        this.resources = this.experience.resources

        this.radius = 688 / 2;
        this.numStars = 32;
        this.starSize = 38;

        this.setTexture()
        this.setMaterial()
        this.setStars()

        this.appearAnimation()
    }

    setTexture() {
        this.texture = this.resources.items.itv_shape_star;
        this.texture.colorSpace = SRGBColorSpace;
        
        // Enable mipmaps and set optimal filtering
        this.texture.generateMipmaps = true;
        this.texture.minFilter = LinearMipmapLinearFilter; // Trilinear filtering
        this.texture.magFilter = LinearFilter;
        this.texture.wrapS = ClampToEdgeWrapping;
        this.texture.wrapT = ClampToEdgeWrapping;
        
        // Apply maximum anisotropic filtering
        if (this.experience.renderer.maxAnisotropy) {
            this.texture.anisotropy = this.experience.renderer.maxAnisotropy;
        }
    }

    setMaterial() {
        this.material = new MeshBasicMaterial({
            map: this.texture,
            transparent: true,
            opacity: 0.5,
            depthTest: false,
            depthWrite: false,
            premultipliedAlpha: true,
            alphaTest: 0.001 // Helps with edge quality
        })
    }

    setStars() {
        this.backgroundStars = this.createCircleOfStars(this.radius * this.sizes.rem, this.numStars, this.starSize * this.sizes.rem);
        this.scene.add(this.backgroundStars);
    }

    createCircleOfStars(radius, numStars, starSize) {
        const group = new Group();
        const angleStep = (Math.PI * 2) / numStars;

        const geometry = new PlaneGeometry(starSize, starSize, 1, 1);

        this.stars = [];

        for (let i = 0; i < numStars; i++) {
            const material = this.material.clone();
            const star = new Mesh(geometry, material);

            const angle = angleStep * i;
            const x = Math.cos(angle) * radius;
            const y = Math.sin(angle) * radius;

            star.position.set(x, y, 0);

            star.rotation.z = angle + Math.PI / 2;

            this.stars.push(star);

            group.add(star);
        }

        this.setSizes(group)

        return group;
    }

    setSizes(group) {
        const position = this.calcGroupPosition();
        const scale = this.sizes.breakpoints.isMobile ? 0.5 : 1;

        group.position.x = position.x
        group.position.y = position.y

        group.scale.set(scale, scale, scale)
    }

    calcGroupPosition() {
        return {
            x: this.sizes.breakpoints.isMobile ? 1 : this.sizes.width * this.sizes.rem / 2 / this.sizes.scaleY + this.radius * .7 * this.sizes.rem,
            y: this.sizes.breakpoints.isMobile ? 1 : 0
        };
    }

    appearAnimation() {
        const timeline = gsap.timeline();

        this.stars.forEach((star, index) => {
            timeline.from(star.material, {
                opacity: 0,
                duration: 1,
                ease: "power2.out",
            }, index * 0.15)
        })

        timeline.from(this.backgroundStars.rotation, {
            z: -Math.PI,
            duration: 3,
            ease: "power2.out",
        }, 0)
    }

    resize() {
        this.setSizes(this.backgroundStars)
    }
}
